import Button from '@ixigo/iui/Button';
import { useState } from 'react';
import Dialog from '../Dialog';
import DialogHeader from '../DialogHeader';
import { WidgetProps } from './index.types';

type ColorPalette = 'neutral' | 'brand' | 'primary' | 'info' | 'success' | 'warning' | 'danger';

type IframeData = {
    url: string;
    displayMode?: 'bottomsheet' | 'drawer';
    button: {
        text?: string;
        variant?: 'solid' | 'outlined' | 'flat';
        color?: string;
    };
    title?: string;
};

const isValidColorPalette = (color: string | undefined): color is ColorPalette => {
    const validColors: ColorPalette[] = ['neutral', 'brand', 'primary', 'info', 'success', 'warning', 'danger'];
    return color !== undefined && validColors.includes(color as ColorPalette);
};

function IframeContent({ message, widgetData }: WidgetProps) {
    const data = widgetData.parameters as IframeData;
    const [open, setOpen] = useState(false);

    if (!data?.url) {
        return null;
    }

    const buttonText = data.button.text || 'View Booking History';
    const buttonVariant = data.button.variant || 'outlined';
    const buttonColor: ColorPalette = isValidColorPalette(data.button.color) ? data.button.color : 'brand';

    const handleButtonClick = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const renderIframe = () => (
        <iframe src={data.url} className='w-full h-full border-0' title={data.title || 'Embedded Content'} />
    );

    return (
        <>
            <Button
                variant={buttonVariant}
                color={buttonColor}
                className='w-fit mt-5 !px-20 !py-[8px]'
                onClick={handleButtonClick}
            >
                {buttonText}
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                classes={{ container: '!min-w-full !h-[550px] lg:!max-h-[calc(100%-120px)]' }}
            >
                <div className='flex flex-col h-full'>
                    {data.title && <DialogHeader title={data.title || 'Embedded Content'} onClose={handleClose} />}
                    <div className='flex-1 overflow-hidden p-1'>{renderIframe()}</div>
                </div>
            </Dialog>
        </>
    );
}

export default IframeContent;
